export const CONTENT_SIDE_PADDING = '24px';
export const CONTENT_MAX_WIDTH_PX = 1280;
export const MOBILE_VIEW_BREAKPOINT = '860px';
export const CALENDLY_KOBIASHOV = 'https://calendly.com/kobiashov';
